<template>
  <v-app id="app">
    <LoaderOverlay />
    <ErrorOverlay />
    <!-- <span style="font-size: 10x"
      >{{ guestRef }} <br />{{ guestStore.guest }}</span
    > -->
    <v-main>
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="12" style="max-width: 950px">
            <router-view style="background-color: #fff; width: 100%" />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-dialog
      v-model="berechnungStore.showPopApp"
      :width="sharedDataStore.isMobile() ? '100%' : 888"
      :fullscreen="sharedDataStore.isMobile()"
      scrollable
    >
      <v-card class="pa-4" rounded="0">
        <v-row
          ><v-col cols="11"></v-col
          ><v-col cols="1"
            ><v-btn icon @click="berechnungStore.closePopApp">
              <v-icon>mdi-close</v-icon>
            </v-btn></v-col
          ></v-row
        >
        <InfoPaket
          v-if="berechnungStore.showPopAppType == 'infopaket'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnungStore.berechnung"
        />
        <SofortPop
          v-if="berechnungStore.showPopAppType == 'sofortpop'"
          :tarif="berechnungStore.tarif"
          :berechnung="berechnungStore.berechnung"
        />
        <MenueDefault
          v-if="berechnungStore.showPopAppType == 'menuedialog'"
          :berechnung="berechnungStore.berechnung"
        />
        <erst-info-pop v-if="berechnungStore.showPopAppType == 'erstinfopop'" />
        <AlleBerechnungen
          v-if="berechnungStore.showPopAppType == 'alleberechnungen'"
        />
        <AltersrueckPop
          v-if="berechnungStore.showPopAppType == 'altersrueck'"
        />
        <ClearmentSchutz
          v-if="berechnungStore.showPopAppType == 'clearmentschutz'"
        />

        <ClearmentCheck
          v-if="berechnungStore.showPopAppType == 'clearmentcheck'"
        />
        <TarifOptions
          :tarif="berechnungStore.tarif"
          v-if="berechnungStore.showPopAppType == 'showTarifOptions'"
        />
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="berechnungStore.showPopChat" width="888">
      <ChatWindow v-if="berechnungStore.showPopChat" />
    </v-dialog> -->
  </v-app>
</template>

<script setup>
  import { ref, onMounted, nextTick, watch, watchEffect } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  import { useGuestStore } from "@/stores/guest";
  import { useSharedDataStore } from "@/stores/sharedData";

  import LoaderOverlay from "@/components/base/LoaderOverlay.vue";
  import ErrorOverlay from "@/components/base/ErrorOverlay.vue";
  import AlleBerechnungen from "@/components/berechnung/vergleich/AlleBerechnungen";
  import InfoPaket from "@/components/berechnung/info/InfoPaket";
  import ErstInfoPop from "@/components/berechnung/info/ErstInfoPop";
  import AltersrueckPop from "@/components/berechnung/info/AltersrueckPop";
  import SofortPop from "@/components/tarif/info/SofortPop";
  // import MenueRechner from "@/components/berechnung/MenueRechner";
  // import MenueNeu from "@/components/berechnung/MenueNeu";
  import ClearmentSchutz from "@/components/tarif/info/ClearmentSchutz";
  import ClearmentCheck from "@/components/berechnung/info/ClearmentCheck";
  import TarifOptions from "@/components/tarif/TarifOptions";
  //import ChatWindow from "@/components/chat/ChatWindow";
  import { useRoute } from "vue-router";

  import { useLoaderStore } from "@/stores/loaderStore";
  //import { useRoute } from "vue-router";
  import { useErrorStore } from "@/stores/errorStore";
  const errorStore = useErrorStore();
  import BaseCalls from "@/services/BaseCalls";
  const loaderStore = useLoaderStore();
  // const route = useRoute();
  const route = useRoute();

  const berechnungStore = useBerechnungStore();
  const guestStore = useGuestStore();
  const sharedDataStore = useSharedDataStore();

  import MenueDefault from "@/components/site/MenueDefault.vue";

  // import LoaderOverlay from "@/components/base/LoaderOverlay.vue";
  // import SuccessOverlay from "@/components/base/SuccessOverlay.vue";

  const lastBerechnung = ref(false);

  const stopMenue = ref(false);
  const userId = ref(route.params.userid);
  const guestRef = ref("");
  const updateRef = ref(false);
  const guestIframe = ref(false);
  const tokenIframe = ref(false);
  const vmIframe = ref(false);
  const guestAlreadyThere = ref(false);
  const contentHeight = ref(0);

  const adjustedTop = ref(150);

  window.addEventListener("message", (event) => {
    if (event.data.type === "scrollUpdate") {
      adjustedTop.value = event.data.scrollPosition + 30; // Einfaches Beispiel: direkte Zuweisung
    } else if (event.data.type === "parentUrl") {
      if (event.data.url) {
        guestRef.value = event.data.url;
        console.log("guestRef Event: " + event.data.url);
      }
    } else if (event.data.type === "guestData") {
      if (event.data.token && event.data.guest) {
        guestIframe.value = event.data.guest;
        tokenIframe.value = event.data.token;
        vmIframe.value = event.data.vm;
        getGuestFromIframe();
        //console.log("iframeCookie recevied" + guestIframe.value);
      }
    }
  });

  // Funktion, um die Höhe des Inhalts zu messen
  function measureContentHeight() {
    const contentElement = document.getElementById("app");
    if (contentElement) {
      return contentElement.offsetHeight;
    }
    return 0;
  }

  function sendGuestToParent(vm, guest, token) {
    console.log("sendGuestdatatoParent");
    if (window.parent !== window) {
      const guestData = {
        vm: vm,
        guest: guest,
        token: token,
      };
      window.parent.postMessage({ guestData: guestData }, "*");
    } else {
      console.log("Nicht in einem iframe ausgeführt.");
    }
  }

  function sendHeightToParent(newHeight) {
    window.parent.postMessage(
      {
        frameHeight: newHeight,
      },
      "*"
    );
  }

  async function getLastBerechnung(guest_id) {
    let berSelect = {};
    berSelect.action = "getLastBerechnung";
    berSelect.ber_guest_id = guest_id;
    console.log("get berechnung " + berSelect.ber_guest_id);
    try {
      const resp = await BaseCalls.postBerechnung(berSelect); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.berechnung) {
        lastBerechnung.value = resp.data.berechnung;
        berechnungStore.setBerechnung(resp.data.berechnung);
        console.log("last berechnung ");
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  async function updateGuestRef(guest_id) {
    let select = {};
    select.action = "updateGuestRef" + guest_id;
    console.log("updateGuestRef " + guestRef.value);
    select.guest_id = parseInt(guest_id);
    select.guest_ref = guestRef.value;
    BaseCalls.postChat(select);
    updateRef.value = true;
  }

  async function getGuestFromIframe() {
    let guestSelect = {};
    guestSelect.action = "getGuestFromIframe";
    guestSelect.guest = guestIframe.value;
    guestSelect.token = tokenIframe.value;
    try {
      const resp = await BaseCalls.postGuest(guestSelect); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.guest) {
        console.log("cookieFromIframe: " + resp.data.guest.guest_id);
        guestStore.setGuest(resp.data.guest);
        guestAlreadyThere.value = true;
      } else {
        checkInsertGuest();
      }
    } catch (err) {
      console.log("error guest iframe");
    }
  }

  async function checkInsertGuest() {
    let guestSelect = {};
    console.log("checkInsertGuest + Ref: " + guestRef.value);
    guestSelect.action = "checkInsertGuest";
    guestSelect.guest_user_id = route.params.userid;
    guestSelect.guestRef = guestRef.value;
    console.log("checkInsertGuest " + guestSelect.guest_user_id);
    try {
      const resp = await BaseCalls.postGuest(guestSelect); // Korrigiert, um .value zu verwenden
      if (resp.data && resp.data.guest) {
        console.log("cookieFromServer: " + resp.data.guest.guest_id);
        guestStore.setGuest(resp.data.guest);
        sendGuestToParent(
          resp.data.guest.guest_user_id,
          resp.data.guest.guest_id,
          resp.data.guest.guest_identity_token
        );
        // updateGuestRef(resp.data.guest.guest_id);
        console.log("last guest");
        getLastBerechnung(resp.data.guest.guest_id);
      }
    } catch (err) {
      console.log("error berechnung");
    }
  }

  function checkMenue() {
    const pattern =
      /^\/(angebot(\/(?!(id\/?\d*))[^\s]*)?|vergleich\/starten(\/.*)?|rechner\/\d+\/starten|startnew\/\d+|start\/\d+)$/;

    if (pattern.test(route.path)) {
      console.log("closeMenu");
      stopMenue.value = true;
    } else {
      console.log("closeMenuFalse");
      stopMenue.value = false;
    }
  }
  watchEffect(() => {
    // Verzögert die Prüfung der Bedingung um 1 Sekunde (1000 Millisekunden)
    setTimeout(() => {
      if (route.params.userid > 0 && !guestAlreadyThere.value) {
        console.log("userid changed effect: " + route.params.userid);
        checkInsertGuest();
      }
    }, 1000);
  });

  watch(
    () => route.params.userid,
    (newUserId) => {
      console.log("userid changed watch: " + newUserId);
      userId.value = newUserId;
    }
  );

  watch(
    () => guestRef.value,
    () => {
      if (
        !updateRef.value &&
        guestRef.value != "" &&
        guestStore.guest.guest_ref == "" &&
        guestStore.guest.guest_id > 0
      ) {
        updateGuestRef(guestStore.guest.guest_id);
      }
    }
  );

  watch(
    () => loaderStore.load,
    () => {
      if (loaderStore.load) {
        console.log("loaderStore true");
        sendHeightToParent(700);
      }
    }
  );
  watch(
    () => errorStore.error,
    () => {
      if (errorStore.error) {
        console.log("error true");
        sendHeightToParent(700);
      }
    }
  );

  watch(
    () => [route.path, route.params, route.query],
    () => {
      checkMenue();
      window.scrollTo(0, 0);
    },
    {}
  );

  onMounted(() => {
    sendHeightToParent(700);

    nextTick(() => {
      contentHeight.value = measureContentHeight();

      watch(contentHeight, (newHeight, oldHeight) => {
        if (
          Math.abs(newHeight - oldHeight) > 50 &&
          !berechnungStore.tarif.showPopYes &&
          !berechnungStore.showPopApp
        ) {
          sendHeightToParent(newHeight);
        }
      });

      watch(
        [
          () => berechnungStore.tarif.showPopYes,
          () => berechnungStore.showPopApp,
        ],
        () => {
          if (berechnungStore.tarif.showPopYes || berechnungStore.showPopApp) {
            sendHeightToParent(750);
          }
          if (
            !berechnungStore.tarif.showPopYes &&
            !berechnungStore.showPopApp
          ) {
            sendHeightToParent(contentHeight.value);
          }
        }
      );
      // Optional: Höhe regelmäßig überprüfen
      setInterval(() => {
        const newHeight = measureContentHeight();
        if (newHeight !== contentHeight.value) {
          contentHeight.value = newHeight;
        }
      }, 1000); // Überprüfen jede Sekunde
    });
  });
</script>

<style>
  :root {
    --wz-blue: #0f4c81;
    --wz-blue-soft: #f0f5fa;
    --wz-blue-tint: #f7faff;
    --wz-yellow: #fecf0c;
    --wz-orange: #f6a800;
    --wz-orange-bg: #fff3e0;
    --wz-rec-bg: #fff5cc;
    --wz-rec-border: #ffe58f;
    --wz-rec-text: #8a6d00;
    --wz-green: #2e7d32;
    --wz-green-bg: #e7f3ea;
    --wz-green-border: #c5e1cb;
    --wz-red: #b91c1c;
    --wz-red-soft: #c1272d;
    --wz-red-bg: #fff1f1;
    --wz-red-border: #fbd5d5;
    --wz-turk: #088a85;
    --wz-ink: #0f172a;
    --wz-ink-2: #1f2937;
    --wz-ink-3: #4b5563;
    --wz-ink-4: #5b6473;
    --wz-ink-5: #6b7280;
    --wz-ink-6: #9ca3af;
    --wz-surface: #ffffff;
    --wz-surface-1: #fafbfc;
    --wz-surface-2: #f5f7fb;
    --wz-surface-3: #f7f9fc;
    --wz-surface-4: #fbfcfe;
    --wz-surface-tint: #f7faff;
    --wz-surface-blue: #f0f5fa;
    --wz-border: #d8dde5;
    --wz-border-2: #e5e9f0;
    --wz-border-3: #eef1f6;
    --wz-border-input: #c8d0db;
    --wz-border-blue: #d8e3ee;
  }

  html {
    font-size: 15px !important;
  }
  body,
  #app {
    color: var(--wz-ink-2);
    background: var(--wz-surface-1);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .fixedFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: var(--wz-surface-2);
    color: var(--wz-ink-4);
    text-align: left;
    padding: 8px;
    z-index: 1000;
    border-top: 1px solid var(--wz-border);
  }

  .caption {
    font-size: 12.5px !important;
    color: var(--wz-ink-5);
  }

  ul {
    margin-left: 20px;
    margin-top: 4px;
    margin-bottom: 8px;
  }
  ol {
    margin-left: 20px;
    margin-top: 8px;
    margin-bottom: 8px;
  }

  a,
  a:link {
    color: var(--wz-blue);
    text-decoration: none !important;
    cursor: pointer;
  }
  a:hover {
    text-decoration: underline !important;
  }

  .redtext,
  .text-red {
    color: var(--wz-red) !important;
  }
  .greentext,
  .text-green {
    color: var(--wz-green) !important;
  }
  .text-orange {
    color: var(--wz-orange) !important;
  }
  .text-blue {
    color: var(--wz-blue) !important;
  }
  .greenground {
    background-color: var(--wz-green) !important;
  }
  .blackground {
    background-color: #1f2937 !important;
  }

  .wtb-chat-app {
    position: fixed;
    bottom: 0;
    right: 0;
    width: 350px;
    max-width: 100%;
    border: 1px solid var(--wz-border);
    z-index: 1000;
    background: var(--wz-surface-2);
  }
  @media (max-width: 780px) {
    .wtb-chat-app {
      width: 100%;
    }
    .v-container {
      padding: 8px !important;
    }
    .v-main {
      padding-top: 8px !important;
    }
  }

  .logo {
    font-size: 32px;
    text-decoration: none;
    font-weight: 800;
    color: var(--wz-blue);
    letter-spacing: -0.4px;
  }
  .logoSmall,
  .logosmall {
    font-size: 22px;
    text-decoration: none;
    font-weight: 800;
    color: var(--wz-blue);
    letter-spacing: -0.3px;
  }
  .sonder {
    font-size: 32px;
    text-decoration: none;
  }

  .header_btn_mobil {
    text-transform: none !important;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
  }
  .header_btn {
    text-transform: none !important;
    font-size: 15px;
  }
  .nocaps,
  .button_caps {
    text-transform: none !important;
    letter-spacing: 0;
  }
  .v-navigation-drawer__border {
    display: none;
  }

  .layout {
    color: var(--wz-ink-2) !important;
  }
  .blue {
    color: var(--wz-blue);
  }
  .blackText {
    color: var(--wz-ink) !important;
  }
  .titleh1 {
    font-size: clamp(20px, 2.4vw, 24px);
    font-weight: 700;
    letter-spacing: -0.3px;
    color: var(--wz-ink) !important;
    margin-bottom: 6px;
    line-height: 1.2;
  }
  .divider {
    border-bottom: 2px solid var(--wz-blue) !important;
    margin-top: 12px;
    margin-bottom: 24px;
  }
  .titleh2 {
    font-size: 15px;
    color: var(--wz-ink) !important;
    font-weight: 700;
  }
  .baseText {
    font-size: 13.5px;
    line-height: 1.45;
  }
  .greyText {
    color: var(--wz-ink-5) !important;
  }
  .textWhite {
    color: #fff !important;
  }
  .greyTextSize {
    font-size: 12.5px !important;
    color: var(--wz-ink-5) !important;
  }
  .blueTitle {
    font-size: 15px;
    font-weight: 700;
    color: var(--wz-blue) !important;
  }
  .titleHome {
    font-size: clamp(26px, 3.4vw, 32px);
    font-weight: 800;
    color: var(--wz-ink);
    letter-spacing: -0.6px;
    line-height: 1.15;
  }
  .headline {
    font-size: clamp(18px, 2.2vw, 22px) !important;
    font-weight: 700;
    color: var(--wz-ink);
    letter-spacing: -0.2px;
    line-height: 1.2;
  }

  .blueground {
    background-color: var(--wz-blue);
  }
  .greenground {
    background-color: var(--wz-green);
  }
  .yellowground {
    background-color: var(--wz-yellow);
  }
  .orangeground {
    background-color: var(--wz-orange);
  }
  .turkground {
    background-color: var(--wz-turk);
  }
  .cianground {
    background-color: #00bcd4;
  }
  .yellowcolor {
    color: var(--wz-yellow);
  }
  .purpleground {
    background-color: #513b83;
  }
  .purplecolor {
    color: #513b83;
  }
  .greyground {
    background-color: var(--wz-surface-2);
  }

  .noUnderline {
    text-decoration: none !important;
  }
  .wordwrap {
    word-break: normal;
  }

  h1,
  h2,
  h3,
  h4 {
    color: var(--wz-ink) !important;
    letter-spacing: -0.2px;
  }
  h2 {
    font-size: clamp(18px, 2.2vw, 22px);
    font-weight: 700;
    line-height: 1.2;
  }
  h3 {
    font-size: 16px;
    font-weight: 700;
    line-height: 1.25;
  }

  .v-application a {
    color: var(--wz-blue);
  }

  .v-field--variant-outlined .v-field__outline {
    --v-field-border-opacity: 0.6;
  }
  .v-icon.mdi-check-bold {
    color: var(--wz-green) !important;
  }
  .v-icon.mdi-alert-circle {
    color: var(--wz-orange) !important;
  }

  .num {
    font-variant-numeric: tabular-nums;
  }

  .pin {
    padding: 1px 8px;
    background: rgba(255, 255, 255, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 3px;
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #fff;
  }

  /* ===== Generic dialog/panel system used by Vergleich pop-ups ===== */
  .dlg {
    padding: 18px 22px 22px;
    color: #1f2937;
    font-size: 13.5px;
    line-height: 1.5;
  }
  @media (max-width: 720px) {
    .dlg {
      padding: 14px 14px 18px;
    }
  }
  .dlg__head {
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eef1f6;
  }
  .dlg__eyebrow {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.8px;
    color: #5b6473;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
    margin-bottom: 6px;
  }
  .dlg__dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0f4c81;
    border-radius: 1px;
    margin-right: 8px;
  }
  .dlg__title {
    font-size: clamp(17px, 2.2vw, 20px) !important;
    font-weight: 700;
    color: #0f172a !important;
    letter-spacing: -0.2px;
    line-height: 1.25;
    margin: 0 0 4px;
  }
  .dlg__title--warn {
    color: #b3261e !important;
  }
  .dlg__sub {
    font-size: 13px;
    color: #4b5563;
    margin: 0;
  }
  .dlg__intro {
    font-size: 13.5px;
    color: #1f2937;
    margin: 0 0 14px;
  }
  .dlg__section {
    margin-top: 18px;
  }
  .dlg__section-title {
    font-size: 14px !important;
    font-weight: 700;
    color: #0f172a !important;
    margin: 0 0 6px;
    letter-spacing: -0.1px;
  }

  .dlg__table-wrap {
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    overflow: auto;
    background: #fff;
  }
  .dlg__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12.5px;
    color: #1f2937;
  }
  .dlg__table th,
  .dlg__table td {
    padding: 8px 10px;
    border-bottom: 1px solid #eef1f6;
    text-align: left;
    vertical-align: top;
  }
  .dlg__table thead th {
    background: #f7f9fc;
    font-size: 10.5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #5b6473;
    font-weight: 700;
    border-bottom: 1px solid #e5e9f0;
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .dlg__table tbody tr:last-child td {
    border-bottom: none;
  }
  .dlg__table tbody tr:hover {
    background: #fafbfd;
  }
  .dlg__table tbody tr.is-self {
    background: #f4f8fc;
  }
  .dlg__table tbody tr.is-self:hover {
    background: #eef4f9;
  }
  .dlg__th-num {
    text-align: right !important;
  }
  .dlg__td-num {
    text-align: right;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
    white-space: nowrap;
  }
  .dlg__td-tarif {
    min-width: 180px;
  }
  .dlg__td-tarif a {
    color: #0f4c81;
    text-decoration: none;
    font-weight: 700;
  }
  .dlg__td-tarif a:hover {
    text-decoration: underline;
  }
  .dlg__td-tarif-sub {
    font-size: 11.5px;
    color: #6b7280;
    margin-top: 2px;
  }
  .dlg__yes {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    background: #ecf6e8;
    color: #2e7d32;
    font-size: 11.5px;
    font-weight: 700;
    border-radius: 11px;
    border: 1px solid #c8e3c1;
  }
  .dlg__no {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    background: #fbf1ee;
    color: #b3261e;
    font-size: 11.5px;
    font-weight: 700;
    border-radius: 11px;
    border: 1px solid #f1ccc4;
  }
  .dlg__tipp {
    display: inline-block;
    background: #ecf6e8;
    color: #2e7d32;
    font-size: 9.5px;
    font-weight: 800;
    padding: 1px 5px;
    margin-left: 4px;
    border-radius: 2px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    border: 1px solid #c8e3c1;
    vertical-align: middle;
  }
  .dlg__link {
    color: #0f4c81;
    cursor: pointer;
    text-decoration: none;
    font-weight: 600;
  }
  .dlg__link:hover {
    text-decoration: underline;
  }
  .dlg__pill {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0.2px;
  }
  .dlg__pill--ok {
    background: #ecf6e8;
    color: #2e7d32;
    border: 1px solid #c8e3c1;
  }
  .dlg__pill--warn {
    background: #fff5f0;
    color: #b3261e;
    border: 1px solid #f5c4ba;
  }
  .dlg__pill--info {
    background: #f0f5fa;
    color: #0f4c81;
    border: 1px solid #cfdde9;
  }
  .dlg__note {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    padding: 10px 12px;
    border-radius: 3px;
    font-size: 12.5px;
    line-height: 1.5;
    margin-top: 10px;
  }
  .dlg__note--ok {
    background: #eef5ec;
    color: #2e7d32;
    border: 1px solid #c8e3c1;
  }
  .dlg__note--warn {
    background: #fff5f0;
    color: #b3261e;
    border: 1px solid #f5c4ba;
  }
  .dlg__note--info {
    background: #f0f5fa;
    color: #0f4c81;
    border: 1px solid #cfdde9;
  }
  .dlg__kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 10px;
    margin-bottom: 14px;
  }
  .dlg__kpi {
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-radius: 3px;
    padding: 10px 12px;
  }
  .dlg__kpi-label {
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #6b7280;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
    margin-bottom: 2px;
  }
  .dlg__kpi-value {
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.3px;
  }
  .dlg__kpi-value--ok {
    color: #2e7d32;
  }
  .dlg__kpi-value--warn {
    color: #b3261e;
  }
  .dlg__btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #0f4c81;
    color: #fff !important;
    text-decoration: none;
    font-size: 12.5px;
    font-weight: 700;
    letter-spacing: 0.2px;
    padding: 6px 10px;
    border-radius: 3px;
    border: 1px solid #0f4c81;
    cursor: pointer;
    white-space: nowrap;
  }
  .dlg__btn:hover {
    background: #0d426f;
  }
  .dlg__btn--ghost {
    background: #fff;
    color: #0f4c81 !important;
    border: 1px solid #cfdde9;
  }
  .dlg__btn--ghost:hover {
    background: #f0f5fa;
  }

  /* Prose-style for long info dialog bodies */
  .dlg__prose {
    font-size: 14px;
    line-height: 1.6;
    color: #1f2937;
  }
  .dlg__prose p {
    margin: 0 0 10px;
  }
  .dlg__prose h3 {
    font-size: 14.5px !important;
    font-weight: 700;
    color: #0f172a !important;
    margin: 16px 0 6px;
    letter-spacing: -0.1px;
  }
  .dlg__prose h3:first-child {
    margin-top: 0;
  }
  .dlg__prose h3 .dlg__prose-eyebrow {
    display: inline-block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #0f4c81;
    background: #f0f5fa;
    border: 1px solid #cfdde9;
    padding: 1px 6px;
    border-radius: 2px;
    margin-right: 6px;
    vertical-align: middle;
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      monospace;
  }
  .dlg__prose ul,
  .dlg__prose ol {
    margin: 0 0 10px;
    padding-left: 22px;
  }
  .dlg__prose ul li,
  .dlg__prose ol li {
    margin: 2px 0;
  }
  .dlg__prose strong,
  .dlg__prose b {
    color: #0f172a;
  }
  .dlg__prose a {
    color: #0f4c81;
    font-weight: 600;
  }
  .dlg__prose .text-green {
    color: #2e7d32 !important;
  }
  .dlg__prose .text-red {
    color: #b3261e !important;
  }
  .dlg__prose .text-orange {
    color: #b25b00 !important;
  }
  .dlg__quote {
    background: #f7f9fc;
    border: 1px solid #e5e9f0;
    border-left: 3px solid #0f4c81;
    border-radius: 3px;
    padding: 10px 14px;
    font-size: 13px;
    color: #1f2937;
    line-height: 1.55;
    margin: 8px 0;
  }
  .dlg__quote-author {
    display: block;
    font-size: 11.5px;
    font-weight: 700;
    color: #0f4c81;
    margin-top: 6px;
  }
</style>

